import { render, staticRenderFns } from "./SimpleLink.vue?vue&type=template&id=cc08386c&"
import script from "./SimpleLink.vue?vue&type=script&lang=js&"
export * from "./SimpleLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports